import {File} from '@/utils/file';
import axios from "axios";
import urljoin from "url-join";

export default class ChemicalService {

    find(searchString, clientChemicalsOnly) {

        let query = "";

        if (clientChemicalsOnly) {
            query = urljoin(query, `?mine=true`);
        }

        if (searchString) {
            query = urljoin(query, `?q=${searchString}`);
        }

        return axios.get(urljoin('/api/v1/chemicals', query));
    }

    downloadRegisteredChemicals() {
        axios.get('/api/v4/chemical-associations.xlsx?active=true', {responseType: 'blob'})
            .then((response) => {
                const contentDisposition = response.headers['content-disposition'];
                const fileName = File.extractFileName(contentDisposition);

                File.download(fileName, response.data);
            });
    }
}
